/* angular:styles/component:css;7a9a76142fb74c0ae8e43d133c7dbf8537beba1ccbef63b7a3921a64e1f05db3;/Users/miguelrodrigues/Desktop/Tectius/exmeapp-ionic6/src/app/components/side-nav/side-nav-icon.component.ts */
:host {
  display: block;
  flex-shrink: 0;
  width: 2rem;
  height: 2rem;
}
.side-nav-icon {
  display: block;
  width: 100%;
  height: 100%;
  line-height: 0;
}
:host ::ng-deep svg {
  display: block;
  width: 100%;
  height: 100%;
}
:host ::ng-deep .p1 {
  fill: var(--ion-color-primary-icon);
}
:host ::ng-deep .p2 {
  fill: var(--ion-color-secondary-icon);
}
:host.side-nav-icon--inverted ::ng-deep .p1 {
  fill: var(--ion-color-secondary-icon);
}
:host.side-nav-icon--inverted ::ng-deep .p2 {
  fill: var(--ion-color-primary-icon);
}
/*# sourceMappingURL=side-nav-icon.component.css.map */
